/**
 * Array of all valid token metadata include relations
 * Used for runtime validation
 */
export const VALID_TOKEN_METADATA_RELATIONS = [
    'ownerBusiness',
    'mintCount',
    'burnCount',
    'token'
];
/**
 * Type guard to validate token metadata include relation at runtime
 *
 * @param value - String to validate
 * @returns True if value is a valid TokenMetadataIncludeRelation
 */
export function isValidTokenMetadataRelation(value) {
    return VALID_TOKEN_METADATA_RELATIONS.includes(value);
}
//# sourceMappingURL=token-metadata-include-relation.type.js.map